import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import NewArrivals from './components/NewArrivals';
import ShopByCategory from './components/ShopByCategory';
import BrandStatement from './components/BrandStatement';
import FeaturedCollection from './components/FeaturedCollection';
import Community from './components/Community';
import LocalDelivery from './components/LocalDelivery';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Hero />
      <NewArrivals />
      <ShopByCategory />
      <BrandStatement />
      <FeaturedCollection />
      <Community />
      <LocalDelivery />
      <Newsletter />
      <Footer />
    </div>
  );
}